import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { ComponentHeader, InformationModal, VerifiedModal } from '../common';
import { getAllCalenderApi } from './Api';
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { Button, Col, Image, Row } from "react-bootstrap";
import { API_LIMIT, MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
import editPencil from "../../assets/images/edit-icon.png";
import { CALENDER_VERIFY, SSO_VERIFY, SUBDOMAIN_VERIFY, USER_ROLE_VERIFY } from '../../utils/urls';
import FilterVefiedDropDown from '../common/FilterVefiedDropDown';
import { deleteAuthCommonApi } from "../content/Api";
import { toast } from 'react-toastify';
import { clearIndexedDB } from '../../utils/hooks/useIndexedDB';
import { withRouter } from '../../utils/hoc/withRouter';
import OptionsDropdown from '../../utils/commonComponent/OptionsDropdown';
import { Tag } from 'antd';



class Calender extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.SubDomainCalendar);

    this.state = {
      access: AccesData,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,
      isVerify: false,
      show: false,
      verified: '',
      verifyUrl: ''
    }
  }

  async componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    await clearIndexedDB("canvas", "subdomainTemplate")
    this.props.getAllCalenderApi(this);
  }
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";

    // const search = params.get("search") || "";

    if (prevPage !== page || prevVerified !== verified) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllCalenderApi(this);

      });
    }
  }
  getDetailsCalender = (data) => {
    this.props.history({ pathname: `/calender/details/${data?.uuid}`, state: { "data": data } });
  }

  showEditModal = (rowData = null) => {
    this.props.history({ pathname: `/subdomain/edit-calender`, state: { "data": rowData, "id": rowData.uuid } })
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = async (id) => {
    const res = await deleteAuthCommonApi(`/calender/${id}`);
    // console.log(res)
    if (res.status === 200) {
      this.props.getAllCalenderApi(this);
      this.setState({
        delete: !this.state.delete
      });

    } else {
      toast.error("Somthis wrong...")
    }
  }

  render() {
    const { access } = this.state;

    const { calenderList, totalPages, currentPage } = this.props.subdomainState;

    return (
      <>

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData?.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData?.calenderName} ?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          // name={`this '${this.state.editData?.campaignName}' campaign.`}
          name={`'${this.state.editData?.calenderName}'`}
          show={this.state.show}
          url={CALENDER_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllCalenderApi(this) }}
        />
        <section className="request-section">
          <ComponentHeader
            title="Calendars"
            isSearch={false}
            // placeholder={"Search User"}
            // onChangeMethod={this.onChangeMethod}
            // clearSearch={() => this.clearSearch()}
            primaryBtn={access.createAccess ? "Add Calendar" : ""}
            handlePrimaryBtn={() => {
              this.props.history({ pathname: "/subdomain/add-calender", state: { calenderList } });
            }}
            ctx={this}
          />

          <div className="commom-table-wrapper">
            <CustomTable
              data={calenderList?.list || []}
              columns={[
                {
                  width: 180,
                  title: "Calendar Name",
                  dataIndex: "templateName",
                  className: "name",
                  render: (text, rowData, dataKey) => {
                    return rowData?.calenderName;
                  },
                },
                {
                  width: access.verificationAccess ? 110 : 0,
                  title: "Verified",
                  dataIndex: "isVerified",
                  className: "verify",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    const color = rowData.isVerified ? 'green' : 'orange';

                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                  },
                },
                {
                  width: 200,
                  title: "Calendar Assets",
                  dataIndex: "assets",
                  className: "assets",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return (
                      <div className="d-flex gap-8">
                        <Image title='Calendar Image' className="table-img" src={rowData?.calenderImage} alt="icon" />
                        <Image title='Placeholder Image' className="table-img" src={rowData?.placeholderImage} alt="icon" /> 
                        <Image title='Base Image' className="table-img" src={rowData?.baseImage} alt="icon" /> 
                        <Image title='Frame Image' className="table-img" src={rowData?.frameImage} alt="icon" /> 
                        <Image title='Sample Image' className="table-img" src={rowData?.sampleImage} alt="icon" />
                      </div>
                    )
                  },
                },
                {
                  width: 200,
                  title: "Description",
                  dataIndex: "description",
                  className: "description",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData?.description || 'Na';
                  },
                },
                {
                  width: 90,
                  title: "Action",
                  dataIndex: "",
                  fixed: "right",
                  className: "",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return (
                      <OptionsDropdown
                        editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                        viewHandler={() => this.getDetailsCalender(rowData)}
                        deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                      />

                    );
                  },
                },
              ]}
              message="No data found" // For Pagination
              history={this.props.history}
              location={this.props.location}
              total={totalPages}
              currentPage={currentPage}
              loading={this.state.isLoading}
            />
          </div>
        </section>
      </>
    )
  }
}

const mapStateToProps = state => ({
  subdomainState: state.SubdomainState
});
const mapDispatchToProps = {
  getAllCalenderApi,
}
Calender.propTypes = {
  // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Calender));